import { Box, ClickAwayListener, IconButton } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { SupportedMessageNodes } from "../../../models/generated/graphql";
import MessageInput from "./CaseMessageInput";
import CaseMessages from "./CaseMessages";
import useMessagesStyles from "./use-messages-styles";

interface MessagesRootProps {
	nodeId: string;
	nodeLabel: SupportedMessageNodes;
	deleteMessageCondition: boolean;
	showInput: boolean;
	handleClose?: () => void;
	isExposure?: boolean;
	externalFlowDocumentId?: string;
}

const CaseMessagesRoot: React.FC<MessagesRootProps> = ({
	nodeId,
	nodeLabel,
	showInput,
	deleteMessageCondition,
	handleClose,
	isExposure,
	externalFlowDocumentId,
}) => {
	const { inputRoot, gradientTop } = useMessagesStyles();

	return (
		<ClickAwayListener onClickAway={() => handleClose && handleClose()}>
			<div>
				<Box>
					{handleClose && (
						<Box className={gradientTop}>
							<IconButton onClick={handleClose} size="small">
								<CloseIcon />
							</IconButton>
						</Box>
					)}
					<CaseMessages
						isSettled={!showInput}
						nodeId={nodeId}
						nodeLabel={nodeLabel}
						deleteMessageCondition={deleteMessageCondition}
					/>
				</Box>

				{showInput && (
					<Box className={inputRoot}>
						<MessageInput
							nodeId={nodeId}
							nodeLabel={nodeLabel}
							isExposure={isExposure}
							externalFlowDocumentId={externalFlowDocumentId}
						/>
					</Box>
				)}
			</div>
		</ClickAwayListener>
	);
};

export default CaseMessagesRoot;
